import $ from 'jquery';
import 'owl.carousel';

window.jQuery = $;

const loadProductCarousel = () => {
  const $productCarousel = $('.product-carousel');

  if ($productCarousel.length > 0) {
    $productCarousel.owlCarousel({
      dots: true,
      margin: 30,
      nav: true,
      responsive: {
        0: {
          dots: true,
          items: 1,
          nav: true
        },
        768: {
          items: 3
        },
        992: {
          items: 4
        },
        1200: {
          items: 5
        }
      },
      responsiveRefreshRate: 100
    });
  }
};

export default loadProductCarousel;
